export default __webpack_public_path__ + "static/media/dark-bg-m@2x.124c1ca9.png";